"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appRoutes = void 0;
var mediaStorageTabs_1 = require("Modules/files/constants/mediaStorageTabs");
var qrCodeSettingsTabs_1 = require("Modules/qrCodes/constants/qrCodeSettingsTabs");
var settingsConnectionsTabs_1 = require("Views/Settings/Connections/constants/settingsConnectionsTabs");
exports.appRoutes = {
    register: "/register",
    accountList: "/account-list",
    accountDetails: function (id) { return "/account/".concat(id); },
    confirmTwoFactorEnable: "/confirm-two-factor-enable",
    confirmTwoFactorDisable: "/confirm-two-factor-disable",
    login: "/login",
    recoverUsername: "/recover-username",
    recoverUsernameReveal: "/recover-username-verify",
    onboarding: "/onboarding",
    masterLogin: "/master-login",
    library: "/library",
    libraryMy: "/library/my",
    libraryJoin: "/library/join",
    libraryArchive: "/library/archive",
    libraryTemplates: "/library/templates",
    libraryMyExpertProvider: "/library/my-library",
    libraryCreatedByOthers: "/library/other",
    libraryCreatedByMe: "/library/created-by-me",
    libraryStepTemplates: "/library/step-templates",
    friends: "/social/friends",
    users: "/social/users",
    experts: "/social/experts",
    groups: "/social/groups",
    rewardsPotential: "/rewards/potential",
    rewardsWon: "/rewards/won",
    rewardsLeaderboard: "/rewards/leaderboard",
    traqingStatus: "/traqing/status",
    traqingReports: "/traqing/reports",
    traqingExpertProvider: "/traqing",
    approveUsers: "/to-do/users",
    approveModules: "/to-do/modules",
    approveSteps: "/to-do/steps",
    approveGroups: "/to-do/groups",
    contentReports: "/content-reports",
    logout: "/logout",
    userProfilePath: "/profile/:id",
    userProfile: function (id) { return "/profile/".concat(id); },
    messages: "/social/messages",
    notifications: "/social/notifications",
    moduleDetails: function (id, params) {
        if (params === void 0) { params = ""; }
        return "/modules/".concat(id).concat(params);
    },
    moduleQRCodeJoin: function (id, params) {
        if (params === void 0) { params = ""; }
        return "/module-qr-codes-join/modules/".concat(id).concat(params);
    },
    moduleReport: function (moduleId, userId) {
        return "/traqing/".concat(moduleId, "/reports/").concat(userId);
    },
    moduleOverview: function (id) { return "/modules/".concat(id, "/overview"); },
    moduleOverviewPath: "/modules/:id/overview",
    moduleInviteParticipants: function (id) {
        return "/modules/".concat(id, "/invite-participants");
    },
    moduleInviteParticipantsPath: "/modules/:challengeId/invite-participants",
    moduleUserList: function (id, tab) {
        if (tab === void 0) { tab = ""; }
        return "/modules/".concat(id, "/user-list/").concat(tab);
    },
    moduleUserListUsers: function (id) {
        return "/modules/".concat(id, "/user-list/users");
    },
    moduleUserListUsersPath: "/modules/:id/user-list/users",
    moduleUserListGroups: function (id) {
        return "/modules/".concat(id, "/user-list/groups");
    },
    moduleUserListGroupsPath: "/modules/:id/user-list/groups",
    moduleUserListExperts: function (id) {
        return "/modules/".concat(id, "/user-list/experts");
    },
    moduleUserListExpertsPath: "/modules/:id/user-list/experts",
    moduleUserListApprovers: function (id) {
        return "/modules/".concat(id, "/user-list/approvers");
    },
    moduleUserListApproversPath: "/modules/:id/user-list/approvers",
    moduleUserListParticipants: function (id) {
        return "/modules/".concat(id, "/user-list/participants");
    },
    moduleUserListParticipantsPath: "/modules/:id/user-list/participants",
    moduleUserListPath: "/modules/:id/user-list/:tab?",
    moduleJoinAsGroup: function (id) { return "/modules/".concat(id, "/group-join"); },
    moduleJoinAsGroupPath: "/modules/:challengeId/group-join",
    moduleLeaderboard: function (id) { return "/modules/".concat(id, "/leaderboard"); },
    moduleLeaderboardPath: "/modules/:moduleId/leaderboard",
    stepDetails: function (moduleId, stepId, userId) {
        if (userId === void 0) { userId = 0; }
        return "/modules/".concat(moduleId, "/steps/").concat(stepId).concat(userId ? "/".concat(userId) : "");
    },
    stepTemplateDetails: function (id) { return "/step-templates/".concat(id); },
    stepDetailsPath: "/modules/:challengeId/steps/:stepId/:userId?",
    stepTemplateCreate: "/steps/template/create",
    rewardDetails: function (id) { return "/rewards/".concat(id); },
    rewardDetailsPath: "/rewards/:rewardId",
    traqDetails: function (id) { return "/traqs/".concat(id); },
    traqQRCodeJoin: function (id, params) {
        if (params === void 0) { params = ""; }
        return "/traq-qr-codes-join/traqs/".concat(id).concat(params);
    },
    traqCreate: function (id) {
        if (id === void 0) { id = ""; }
        return "/traq/create/".concat(id);
    },
    traqCreatePath: "/traq/create/:traqId?",
    traqDetailsPath: "/traqs/:traqId",
    publicTraqDetailsPath: "/traqs-public/:traqId",
    traqInviteParticipants: function (id) {
        return "/traqs/".concat(id, "/invite-participants");
    },
    traqInviteParticipantsPath: "/traqs/:traqId/invite-participants",
    traqUserList: function (id, tab) {
        if (tab === void 0) { tab = ""; }
        return "/traqs/".concat(id, "/user-list/").concat(tab);
    },
    traqUserListPath: "/traqs/:id/user-list/:tab?",
    traqUserListUsers: function (id) { return "/traqs/".concat(id, "/user-list/users"); },
    traqUserListUsersPath: "/traqs/:id/user-list/users",
    traqUserListParticipants: function (id) {
        return "/traqs/".concat(id, "/user-list/participants");
    },
    traqUserListParticipantsPath: "/traqs/:id/user-list/participants",
    traqUserListExperts: function (id) {
        return "/traqs/".concat(id, "/user-list/experts");
    },
    traqUserListExpertsPath: "/traqs/:id/user-list/experts",
    traqUserListApprovers: function (id) {
        return "/traqs/".concat(id, "/user-list/approvers");
    },
    traqUserListApproversPath: "/traqs/:id/user-list/approvers",
    publicModuleDetailsPath: "/modules-public/:challengeId",
    moduleCreatePath: "/module/create/:challengeId?",
    moduleCreate: function (id) {
        if (id === void 0) { id = ""; }
        return "/module/create/".concat(id);
    },
    moduleDetailsPath: "/modules/:challengeId",
    settingsGeneral: "/settings/general",
    settingsPermissions: "/settings/permissions",
    settingsManageExpertModuleConnections: function (expertId, moduleId) { return "/settings/connections/".concat(expertId, "/expert-connections/").concat(moduleId); },
    settingsManageExpertModuleConnectionsPath: "/settings/connections/:expertId/expert-connections/:moduleId",
    settingsExpertConnections: "/settings/expert-connections",
    settingsConnectionsPath: "/settings/connections/:tab?",
    settingsConnectionsTab: function (tab) {
        if (tab === void 0) { tab = settingsConnectionsTabs_1.settingsConnectionsTabs.services.value; }
        return "/settings/connections/".concat(tab);
    },
    activityLog: "/activity-log",
    socialUserRequests: "/social/user-requests",
    socialFriendRequests: "/social/friend-requests",
    socialFriendsOfUsers: "/social/friends-of-users",
    socialFriendsOfFriends: "/social/friends-of-friends",
    socialGroupRequests: "/social/group-requests",
    socialExpertInvites: "/social/experts/invites",
    socialExpertAccessRequests: "/social/experts/access-requests",
    socialExpertRequests: "/social/expert-requests",
    socialUserModuleJoinRequests: "/social/users/module-join-requests",
    socialGroupModuleRequests: "/social/group-module-requests",
    groupCreate: "/group/create",
    groupDetails: function (id) { return "/groups/".concat(id); },
    groupDetailsPath: "/groups/:groupId",
    groupMemberManagementPath: "/groups/:groupId/member-management",
    groupModuleManagementPath: "/groups/:groupId/module-management",
    traqingReport: function (id, userId, params) {
        if (userId === void 0) { userId = ""; }
        if (params === void 0) { params = ""; }
        return "/traqing/".concat(id, "/reports").concat(userId ? "/".concat(userId) : "").concat(params);
    },
    traqingReportPath: "/traqing/:moduleId/reports/:userId?",
    traqingUserStatus: function (id) {
        if (id === void 0) { id = ""; }
        return "/traqing/status".concat(id ? "/".concat(id) : "");
    },
    traqingUserStatusPath: "/traqing/status/:userId?",
    traqingUserReports: function (id) {
        if (id === void 0) { id = ""; }
        return "/traqing/reports".concat(id ? "/".concat(id) : "");
    },
    traqingUserReportsPath: "/traqing/reports/:userId?",
    traqingNotesPath: "/traqing/notes/:userId?",
    traqingNotes: function (id) {
        if (id === void 0) { id = ""; }
        return "/traqing/notes".concat(id ? "/".concat(id) : "");
    },
    providerExpertNotes: "/notes",
    chatConversation: function (id) { return "/social/messages/chat/".concat(id); },
    chatConversationPath: "/social/messages/chat/:conversationId",
    profile: function (id) {
        if (id === void 0) { id = ""; }
        return "/profile/".concat(id);
    },
    profilePath: "/profile/:id?",
    profileUserList: function (id, type) {
        return "/profile/".concat(id, "/").concat(type);
    },
    profileUserListPath: "/profile/:id/:type",
    profileModuleList: function (id, type) {
        return "/profile/".concat(id, "/library/").concat(type);
    },
    profileModuleListPath: "/profile/:id/library/:type",
    settingsUserListPath: "/settings/permissions/user-list/:tab/:type?/:id?",
    settingsUserList: function (tab, type, id) {
        if (type === void 0) { type = ""; }
        if (id === void 0) { id = ""; }
        return "/settings/permissions/user-list/".concat(tab).concat(type ? "/".concat(type) : "").concat(id ? "/".concat(id) : "");
    },
    usernameChangeVerify: "/new-username-verify",
    tagsManagement: "/tags",
    tagCreate: "/tag/create",
    tagEditPath: "/tags/:id",
    tagEdit: function (id) { return "/tags/".concat(id); },
    subTagCreatePath: "/tags/:categoryId/subtag/create",
    subTagCreate: function (categoryId) {
        return "/tags/".concat(categoryId, "/subtag/create");
    },
    subTagEditPath: "/tags/:categoryId/subtags/:id",
    subTagEdit: function (tagId, subTagId) {
        return "/tags/".concat(tagId, "/subtags/").concat(subTagId);
    },
    protectedFileDownloadPath: "/protected-file/:id",
    protectedFileDownload: function (id) { return "/protected-file/".concat(id); },
    stepUndoRequestList: "/step/undo-requests",
    resetPassword: "/reset-password",
    resetPasswordRequest: "/reset-password-submit",
    mediaStorage: function (tab) {
        if (tab === void 0) { tab = mediaStorageTabs_1.mediaStorageTabs.all.value; }
        return "/media-storage/".concat(tab);
    },
    qrCodeSettings: function (tab) {
        if (tab === void 0) { tab = qrCodeSettingsTabs_1.qrCodeSettingsTabs.registration.value; }
        return "/settings/qr-codes/".concat(tab);
    },
    qrCodeDoStepConfirmation: function (challengeId, stepId, token) {
        if (token === void 0) { token = undefined; }
        return "/step-qr-code/modules/".concat(challengeId, "/steps/").concat(stepId, "/confirm-by-qr-code").concat(token ? "?token=".concat(token) : "");
    },
};
